import React from "react"
import * as R from "ramda"
import ReactMarkdown from "react-markdown"

import { graphql, useStaticQuery } from "gatsby"

import { BgImage } from "gbimage-bridge"

import Box from "@material-ui/core/Box"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { useTheme } from "@material-ui/core/styles"

const BasicPageLift = ({ pageContent }) => {
  const contentText = R.path(["contentText", "contentText"], pageContent)
  const color = R.path(["color"], pageContent)

  const {
    shape_lightGreen,
    shape_darkGreen,
    shape_yellow,
    shape_pink,
    shape_lightBlue,
  } = useStaticQuery(
    graphql`
      {
        shape_lightGreen: file(relativePath: { eq: "shape_lightGreen.png" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
            )
          }
        }
        shape_darkGreen: file(relativePath: { eq: "shape_darkGreen.png" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
            )
          }
        }
        shape_yellow: file(relativePath: { eq: "shape_yellow.png" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
            )
          }
        }
        shape_pink: file(relativePath: { eq: "shape_pink.png" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
            )
          }
        }
        shape_lightBlue: file(relativePath: { eq: "shape_lightBlue.png" }) {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
            )
          }
        }
      }
    `
  )

  const shapeLightGreen = R.path(
    ["childImageSharp", "gatsbyImageData"],
    shape_lightGreen
  )
  const shapeDarkGreen = R.path(
    ["childImageSharp", "gatsbyImageData"],
    shape_darkGreen
  )
  const shapeYellow = R.path(
    ["childImageSharp", "gatsbyImageData"],
    shape_yellow
  )
  const shapePink = R.path(["childImageSharp", "gatsbyImageData"], shape_pink)
  const shapeLightBlue = R.path(
    ["childImageSharp", "gatsbyImageData"],
    shape_lightBlue
  )

  // Gatsby background images seem to jump around during rendering. Static backgroundsize helps.
  // The following stuff helps to take care of this problem and defines two sizes for mobile/laptop.
  let shapeColor = ""
  let shapeSize = ""
  let shapeMinHeight = ""
  let btnColor = ""

  const theme = useTheme()
  const mobileSizeDetected = useMediaQuery(theme.breakpoints.down("sm"))

  shapeMinHeight = mobileSizeDetected ? "41px" : "190px"

  if (color === "Vihreä") {
    shapeColor = shapeLightGreen
    btnColor = "#55dc73"
    shapeSize = mobileSizeDetected ? "60px 41px" : "190px 129px"
  }
  if (color === "Tummanvihreä") {
    shapeColor = shapeDarkGreen
    btnColor = "#55dc73"
    shapeSize = mobileSizeDetected ? "62px 41px" : "190px 129px"
  }
  if (color === "Keltainen") {
    shapeColor = shapeYellow
    btnColor = "#fae600"
    shapeSize = mobileSizeDetected ? "62px 41px" : "193px 129px"
  }
  if (color === "Sininen") {
    shapeColor = shapeLightBlue
    btnColor = "#69d2fa"
    shapeSize = mobileSizeDetected ? "62px 41px" : "191px 128px"
  }
  if (color === "Pinkki") {
    shapeColor = shapePink
    btnColor = "#ff91d2"
    shapeSize = mobileSizeDetected ? "62px 41px" : "203px 135px"
  }

  return (
    <Box
      style={{
        backgroundColor: "#f5f5ed",
        padding: "54px 35px",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: shapeMinHeight,
          top: "-100px",
          right: "-50px",
        }}
      >
        <BgImage
          image={shapeColor}
          style={{
            minHeight: shapeMinHeight,
            backgroundSize: shapeSize,
            backgroundPositionX: "30px",
          }}
        />
      </div>

      <ReactMarkdown children={contentText} softBreak="br" />
    </Box>
  )
}

export default BasicPageLift
